import { render, staticRenderFns } from "./edit-icon.vue?vue&type=template&id=787a94a7&"
import script from "./edit-icon.vue?vue&type=script&lang=js&"
export * from "./edit-icon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports